<vw-toast-popup [isOpen]="isOpen" width="100%" borderRadius="20px" paddingTop="35%" (close)="onClose()" [toastCustomClass]="'mx-2'">
  <div class="flex flex-col items-center gap-4 px-6 pt-6 pb-8">
    <img src="/assets/images/willy/resized/willy_openhands.png" alt="Willy" class="w-36 object-contain" />
    <p class="text-grey-700 text-sm text-center leading-relaxed">
      {{ 'calendar.climate.info.message' | translate }}
    </p>
    <button
      class="w-full bg-primary text-white rounded-full py-3 text-sm font-medium"
      (click)="onClose()">
      OK
    </button>
  </div>
</vw-toast-popup>
